import moment from 'moment';
import {
  ChainedOfferEventStatus,
  LevelRewardInput,
  LevelRewardInputType,
  SongpopMaestroDropFragmentFragment,
  SongpopMaestroSkuOptionFragmentFragment,
} from '../../../../../__gqltypes__';

export type MaestroPackDrop = SongpopMaestroDropFragmentFragment;
export type MaestroPackSkuOption = SongpopMaestroSkuOptionFragmentFragment;

export const APP_VERSION_OPERATORS = ['>=', '>', '=', '!=', '<=', '<'] as const;

export function dropStatusBadge(drop: MaestroPackDrop, now = moment()): { label: string; variant: string } {
  if (drop.status === ChainedOfferEventStatus.DRAFT) {
    return { label: 'Inactive', variant: 'danger' };
  }
  if (moment(drop.startDate).isAfter(now)) {
    return { label: 'Pending', variant: 'warning' };
  }
  if (moment(drop.stopDate).isBefore(now)) {
    return { label: 'Expired', variant: 'secondary' };
  }
  if (drop.capEnabled && drop.seatsSold >= drop.capSeats) {
    return { label: 'Sold out', variant: 'info' };
  }
  return { label: 'Running', variant: 'success' };
}

export function skuOptionLabel(option: MaestroPackSkuOption): string {
  const placeholders = [option.iosPlaceholder && 'iOS', option.androidPlaceholder && 'Android'].filter(Boolean);
  const suffix = [
    option.retired ? 'retired' : null,
    placeholders.length > 0 ? `not in store yet: ${placeholders.join(' + ')}` : null,
  ]
    .filter(Boolean)
    .join(', ');
  return `${option.id} - USD ${option.cost}${suffix ? ` (${suffix})` : ''}`;
}

export function toRewardInput(reward: { type: string; amount: number; itemId?: string | null }): LevelRewardInput {
  return {
    type:
      Object.values(LevelRewardInputType).find((value) => value === reward.type) ?? LevelRewardInputType.CURRENCY_COIN,
    amount: reward.amount,
    itemId: reward.itemId ?? undefined,
  };
}

export function userIdsToText(userIds?: string[] | null): string {
  return (userIds ?? []).join(', ');
}

export function textToUserIds(text: string): string[] | undefined {
  const ids = text
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);
  return ids.length > 0 ? ids : undefined;
}
